import { createBrowserRouter, RouterProvider } from 'react-router';

import { AddressPageNorlys } from './pages/NorlysAddressPage';
import { AddressPage } from './pages/AddressPage';
import { EstimatePage } from './pages/Estimate';
import { InformationPage } from './pages/NorlysInformationPage';
import NotFoundPage from './pages/404';

export const Router = () => {
  const router = createBrowserRouter([
    { path: '/norlys', element: <AddressPageNorlys /> },
    { path: '/norlys/address', element: <AddressPageNorlys /> },
    { path: '/norlys/information', element: <InformationPage /> },
    { path: '/norlys/calculator/address', element: <AddressPageNorlys /> },
    { path: '/norlys/calculator/information', element: <InformationPage /> },

    { path: '/', element: <AddressPage /> },
    { path: '/:leadOrigin', element: <AddressPage /> },
    { path: '/:leadOrigin/address', element: <AddressPage /> },
    { path: '/:leadOrigin/estimate', element: <EstimatePage /> },

    { path: '/:leadOrigin/calculator', element: <AddressPage /> },
    { path: '/:leadOrigin/calculator/address', element: <AddressPage /> },
    { path: '/:leadOrigin/calculator/estimate', element: <EstimatePage /> },

    { path: '/:leadOrigin/standalone', element: <AddressPage standalone={true} /> },
    { path: '/:leadOrigin/standalone/address', element: <AddressPage standalone={true} /> },
    { path: '/:leadOrigin/standalone/estimate', element: <EstimatePage /> },

    { path: '*', element: <NotFoundPage /> },
  ]);

  return <RouterProvider router={router} />;
};
